import type { AppPort } from '../types';

/** Web: no hardware back (Esc is handled by the UI back stack), never closes the tab, no splash. */
export function createWebApp(): AppPort {
  return {
    onBack: () => () => undefined,
    canExit: false,
    exit: () => undefined,
    ready: () => undefined,
  };
}
